export enum EndsInCustomTypeFilterEnum {
  LESS_THAN = "less_than",
  MORE_THAN = "more_than",
  BETWEEN = "between",
}

export enum EndsInUnitEnum {
  MINUTE = "minute",
  HOUR = "hour",
  DAY = "day",
}

export enum EndsInFilterEnum {
  ALL = "all",
  M15 = "15m",
  H1 = "1h",
  H4 = "4h",
  TODAY = "today",
  H24 = "24h",
  WEEKEND = "weekend",
  D7 = "7d",
  D30 = "30d",
  CUSTOM = "custom",
}
